import { cn } from '@scalis/utils'
import { SeparatorProps } from './separator.types'

export const Separator = ({ done }: SeparatorProps) => {
  return (
    <div className='relative flex-1'>
      <hr
        className={cn('absolute top-1/2 -translate-y-1/2 h-1 w-[calc(100%+12px)] -left-[6px] bg-neutral-30 border-0', {
          'bg-button-brand-primary-dark-hover': done,
        })}
      />
    </div>
  )
}
